var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00142 0.00506141C1.74422 -0.11062 -0.110381 1.77213 0.00511871 4.06564C0.102469 6.02887 1.67327 7.62494 3.60542 7.72553C5.86262 7.84121 7.71722 5.95678 7.60337 3.66327C7.50602 1.70004 5.93522 0.103977 4.00142 0.00506141Z",
    fill: "#FBF9F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2387 10.3208H0.369751V31.5609H7.2387V10.3208Z",
    fill: "#FBF9F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5638 9.8212C20.9205 9.8212 19.0642 11.1021 17.7657 12.7384V10.3208H10.8967V31.5609H17.7657V19.1143C17.9521 16.4402 19.8315 15.7427 21.163 15.7427C22.5672 15.7427 24.3393 16.4368 24.3393 20.3398V31.5609H31.2082V16.5995C31.2082 16.5995 30.8997 9.81953 23.5621 9.81953L23.5638 9.8212Z",
    fill: "#FBF9F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.14de46d0ad3fe94d447221b0f79ab901.svg";
export { ForwardRef as ReactComponent };